export enum NAVIGATION_ITEMS {
  CONVERSATION = 'conversation',
  CONTACTS = 'contacts',
  SETTINGS = 'settings',
}

export const items = [
  {
    id: NAVIGATION_ITEMS.CONVERSATION,
    icon: 'fa-regular fa-messages',
  },
  {
    id: NAVIGATION_ITEMS.CONTACTS,
    icon: 'fa-regular fa-address-book',
  },
  {
    id: NAVIGATION_ITEMS.SETTINGS,
    icon: 'fa-regular fa-gear',
  },
];
